import { getClientLocale, i18n } from '@flipp/shopper-ad-web-shared';
import './taboola.css';

interface TaboolaFooterProps {
  readonly validFrom: string;
  readonly validTo: string;
  readonly container?: HTMLElement;
}

export function createTaboolaFooter({
  validFrom,
  validTo,
  container,
}: Readonly<TaboolaFooterProps>) {
  if (!validFrom || !validTo) {
    return null;
  }

  const locale = getClientLocale();

  const footer = document.createElement('div');
  footer.className = 'taboola-footer';

  const dates = document.createElement('div');
  dates.className = 'taboola-footer-dates';
  const fromDate = new Date(validFrom);
  const toDate = new Date(validTo);
  const formattedFrom = fromDate.toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
  });
  const formattedTo = toDate.toLocaleDateString(locale, {
    month: 'short',
    day: 'numeric',
  });

  dates.textContent = i18n('valid_from_to', {
    from: formattedFrom,
    to: formattedTo,
  });
  footer.appendChild(dates);

  if (container) {
    container.appendChild(footer);
  }

  return footer;
}
